let groupId = null;

export const setGroupId = (id) => {
	groupId = id;
};

export const getGroupId = () => groupId;
